/** In-conversation "reconnecting" affordance shown while Kelly opens a thread's in-flight stream on select
 *  (APP-3376) — the disabled send button alone wasn't obvious. A floating pill pinned above the composer;
 *  cleared the instant the first reattached content streams in (bound to isReconnecting, not isReattaching). */

import { Typography } from "@mui/material"
import { ChatStatusPill, ChatStatusSpinner, FLOATING_PILL_SX } from "./chat-pill"

export function ReattachIndicator() {
  return (
    <ChatStatusPill sx={FLOATING_PILL_SX} role="status" aria-live="polite" data-testid="chatbox-reattach-indicator">
      <ChatStatusSpinner aria-hidden />
      <Typography variant="body2" color="inherit">Reconnecting to your conversation…</Typography>
    </ChatStatusPill>
  )
}
